
import { useEffect, useState } from 'react';

export default function useMediaQuery(minWidth: number) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const media = window.matchMedia(`(min-width: ${minWidth}px)`);
      
      const updateMatches = () => {
        setMatches(media.matches);
      };

      updateMatches(); 

      media.addEventListener('change', updateMatches);
      
      return () => {
        media.removeEventListener('change', updateMatches);
      };
    }
  }, [minWidth]);

  return matches;
}
